import { render, staticRenderFns } from "./vImageUpload.vue?vue&type=template&id=fc498f3c&scoped=true"
import script from "./vImageUpload.vue?vue&type=script&lang=js"
export * from "./vImageUpload.vue?vue&type=script&lang=js"
import style0 from "./vImageUpload.vue?vue&type=style&index=0&id=fc498f3c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc498f3c",
  null
  
)

export default component.exports